import React from 'react';

const Contact = () => {
    return <h2>Contact Us</h2>;
};

export default Contact;